import React from "react";
import { Link } from "react-router-dom";

export default function Login() {
  return (
    <div className="min-h-screen flex flex-col justify-between bg-linear-to-b from-gray-100 via-green-100 to-green-700 ">

      {/*content wrapper */}
      <div className="w-full">

      {/* Header Section */}
      <header className="px-6 py-8 w-full">
        <h1 className="text-2xl font-bold text-black">FINCA</h1>
      </header>

      <h1 className="text-3xl md:text-4xl  font-bold text-center mb-8 md:mb-14">Login</h1>

      <div className="flex justify-center px-6 ">

        {/* Form Section */}
        <form className="w-full max-w-md flex flex-col gap-4 md:gap-6">

          {/* Email Field */}
          <div className="flex flex-col gap-2">
            <label className="font-semibold ml-1">Email</label>
            <input
              type="email"
              className="w-full h-12 rounded-2xl bg-white shadow-lg shadow-[#194e20] px-4 focus:outline-none focus:ring-2 focus:ring-green-800 transition"
            />
          </div>

          {/* Password Field */}
          <div className="flex flex-col gap-2 relative">
            <div className="flex justify-between items-center px-1">
              <label className="font-bold text-black">Password</label>
              <span className="text-sm text-gray-600 cursor-pointer hover:underline">
                {" "}
                Forgot password?{" "}
              </span>
            </div>
            <input
              type="password"
              className="w-full h-12 rounded-2xl bg-white shadow-lg shadow-[#194e20] px-4 focus:outline-none focus:ring-2 focus:ring-green-800 transition"
            />
          </div>

          {/* Register Button */}
          <button
            type="submit"
            className="mt-8 self-center bg-black text-white px-10 py-4 rounded-full flex items-center gap-12 hover:bg-[#194e20] transition shadow-xl"
          >
            <span className="font-bold text-lg">Login</span>
            <span className="text-xl">→</span>
          </button>
        </form>
      </div>

      {/* Footer Links */}
      <div className="mt-10 mb-4 text-white text-center">
        <p className="mb-12">
          Don't have an account?{" "}
          <Link to="/register" className="underline hover:text-black hover:font-extrabold hover:no-underline cursor-pointer font-medium ml-2">
            Register here
          </Link>
        </p>
      </div>
      </div>

      {/* Footer-copyright*/}
      <footer className="px-6 py-6 text-center">
        <p className="text-white opacity-80 text-sm">
          Copyright © 2025 AADA. All rights reserved.
        </p>
      </footer>
    </div>
  );
}


